type EventCallback<T = any> = (data: T) => void;

class EventEmitter {
  private events: Record<string, EventCallback[]> = {};

  on<T>(event: string, callback: EventCallback<T>) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  emit<T>(event: string, data: T) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => callback(data));
    }
  }

  off(event: string) {
    if (this.events[event]) {
      delete this.events[event];
    }
  }
}

export const eventEmitter = new EventEmitter();